<template>
<div>
    <div class="form-group">
        <label for="manufacturer_id" style="font-size: .9em;">Manufacturer</label>
        <select :disabled="disabled" v-model="manufacturer_id" name="manufacturer_id" class="form-control" style="font-size: .9em;" @change="handleManufacturerChange">
            <option value="%">All</option>
            <option v-for="manufacturer in sortedManufacturers" :value='manufacturer.id'>{{ manufacturer.label }}</option>
        </select>
    </div>
    <div class="form-group">
        <label for="model_id" style="font-size: .9em;">Model</label>
        <select :disabled="disabled" v-model="model_id" name="model_id" class="form-control" style="font-size: .9em;" @change="handleModelChange">
            <option value="%">All</option>
            <option v-for="model in manufacturerModels" :value='model.id'>{{ model.name }}</option>
        </select>
    </div>
</div>
</template>

<script>
    export default {
        props: { 
            filterOptions: { default() { return { manufacturers: [], models: [] } } }, 
            value: { default() { return ''; } },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        mounted() {
            this.setControlValues(this.value);
        },
        data() {
            return {
                manufacturer_id: '%',
                model_id: '%',
            };
        },
        watch: {
            value(ids) {
                this.setControlValues(ids);
            }
        },
        computed: {
            sortedManufacturers() {
                let sorted = [];

                for (let i in this.filterOptions.manufacturers) {
                    sorted.push({id: i, label: this.filterOptions.manufacturers[i]});
                }

                return sorted.sort((a, b) => {
                    if (a.label > b.label) {
                        return 1;
                    } else if(a.label < b.label) {
                        return -1;
                    }

                    return 0;
                });
            },
            manufacturerModels() {
                let models = {};
                for (let i in this.filterOptions.models) {
                    if (this.filterOptions.models[i].manufacturer_id.toString() === this.manufacturer_id.toString()) {
                        models[this.filterOptions.models[i].id] = { 
                            id: this.filterOptions.models[i].id, 
                            name: this.filterOptions.models[i].name 
                        };
                    }
                }

                return _.orderBy(models, ['name'], ['asc']);
            }
        },
        methods: {
            setControlValues(ids) {
                ids = ids.split(':');
                if (ids.length === 2) {
                    this.manufacturer_id = ids[0];
                    this.model_id = ids[1];
                } else {
                    console.error('Could not set manufacturer / make data to control.');
                }
            },
            handleManufacturerChange(e) {
                this.model_id = '%';
                this.$emit('input', [this.manufacturer_id, this.model_id].join(':'));
            },
            handleModelChange(e) {
                this.$emit('input', [this.manufacturer_id, this.model_id].join(':'));
            }
        }
    }
</script>